import {cn} from '@sollapay/ui';
import {Icon, Tooltip} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {TRUST_ACCOUNT_ROLE_CONFIG} from '../config';

import type {TrustAccountAccessSection} from '../utils';
import type {FC} from 'react';

export interface TrustAccountRoleBadgeProps {
  accessRole: TrustAccountAccessSection;
}

/** The caller's role on the account, as a corner badge on its tile; the tooltip names it. */
export const TrustAccountRoleBadge: FC<TrustAccountRoleBadgeProps> = ({accessRole}) => {
  const {t} = useTranslation('trustAccounts');
  const {icon, badgeClassName} = TRUST_ACCOUNT_ROLE_CONFIG[accessRole];
  const label = t(`accessFilter.${accessRole}`);

  return (
    <Tooltip content={label}>
      <span
        role="img"
        aria-label={label}
        data-slot="role-badge"
        data-role={accessRole}
        className={cn(
          'flex size-4.5 items-center justify-center rounded-full ring-2 ring-background-surface',
          badgeClassName
        )}
      >
        <Icon name={icon} aria-hidden className="size-2.75" />
      </span>
    </Tooltip>
  );
};
